import { render, staticRenderFns } from "./LayoutTitle.vue?vue&type=template&id=372ece88&"
import script from "./LayoutTitle.vue?vue&type=script&lang=js&"
export * from "./LayoutTitle.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports